import { userAuthStore } from "@/business/auth/infrastructure/store/userAuthStore";

export const isMemoryEmptyService = {
  async execute(): Promise<boolean> {
    return userAuthStore().isEmpty.value;
  },
};